var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26,
    fill: "url(#paint0_linear_538_816)",
    fillOpacity: 0.12,
    stroke: "url(#paint1_linear_538_816)",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8118 23.748C21.8118 22.6 22.7358 21.76 24.3038 21.76C25.7038 21.76 26.6838 22.264 28.0558 23.328C28.2798 23.496 28.4758 23.468 28.6438 23.244L30.1838 21.368C30.3518 21.144 30.3518 20.976 30.1558 20.78C28.6158 19.212 26.6278 18.176 24.1918 18.176C20.9718 18.176 18.0878 20.248 18.0878 23.664C18.0878 30.076 27.2438 28.984 27.2438 32.456C27.2438 33.856 25.9278 34.752 24.2758 34.752C22.5678 34.752 21.2518 34.024 19.9078 32.848C19.6838 32.652 19.4598 32.68 19.2918 32.876L17.6118 34.696C17.4438 34.892 17.4438 35.088 17.5838 35.284C18.7598 36.908 21.3358 38.336 24.1918 38.336C27.6078 38.336 30.9958 36.236 30.9958 32.54C30.9958 25.736 21.8118 27.192 21.8118 23.748Z",
    fill: "url(#paint2_linear_538_816)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0786 12.576H34.5586C34.3346 12.576 34.1946 12.66 34.0826 12.912L32.4026 16.44C32.2626 16.748 32.4306 16.916 32.7386 16.916H35.2586C35.4826 16.916 35.6226 16.832 35.7346 16.58L37.4146 13.052C37.5546 12.744 37.3866 12.576 37.0786 12.576ZM31.9826 18.82V37.58C31.9826 37.832 32.1506 38 32.4026 38H35.3986C35.6506 38 35.8186 37.832 35.8186 37.58V18.82C35.8186 18.568 35.6506 18.4 35.3986 18.4H32.4026C32.1506 18.4 31.9826 18.568 31.9826 18.82Z",
    fill: "url(#paint3_linear_538_816)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_816",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFFCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_538_816",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFFCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_538_816",
    x1: 16,
    y1: 10,
    x2: 36.5627,
    y2: 36.6106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFFCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_538_816",
    x1: 16,
    y1: 10,
    x2: 36.5627,
    y2: 36.6106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BDD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFFCD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi);
export default __webpack_public_path__ + "static/media/si.ca6beabc6ed58c4452da3ed386cee3fc.svg";
export { ForwardRef as ReactComponent };